import { generatePath } from 'react-router';
import { ENTITY_PARAM_NAME, FORM_MODE_TO_PATH_MAP, MODE_PARAM_NAME, MODULE_PARAM_NAME } from 'config/routes';
import { ACCOUNT_ID_PARAM_NAME, ENTITY_TO_PATH_MAP, PUSH_API_ID_PARAM, MODULE_NAME } from '../config';

export const generatePushApiReportFormPath = (
    pathTemplate,
    { module = MODULE_NAME, entity, mode, accountId, subscriptionId }
) => {
    const modePath = FORM_MODE_TO_PATH_MAP[mode];
    const entityPath = ENTITY_TO_PATH_MAP[entity];
    return generatePath(pathTemplate, {
        [MODULE_PARAM_NAME]: module,
        [ENTITY_PARAM_NAME]: entityPath,
        [MODE_PARAM_NAME]: modePath,
        [ACCOUNT_ID_PARAM_NAME]: accountId,
        [PUSH_API_ID_PARAM]: subscriptionId,
    });
};
